let $slider_review; 
$(document).ready(function () {
  $slider_review = $(".block__custom-review-innerwrapper");
  if ($slider_review.length) {
    $slider_review.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      swipe: true,
      touchMove: true,
      draggable: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $slider_review.on("setPosition", equalizeSlickHeights);
  }
});

let isScrolling = false;
const deltaThreshold = 20;
const scrollTimeout = 1000;
const sliderEl = document.querySelector(".block__custom-review-innerwrapper");

if (sliderEl) {
  sliderEl.addEventListener("wheel", function (e) {
    const delta = e.deltaY || e.deltaX;

    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      return;
    }

    if (Math.abs(delta) < deltaThreshold) return;

    if (!isScrolling) {
      isScrolling = true;

      if (delta > 0) {
        $slider_review.slick("slickNext");
      } else {
        $slider_review.slick("slickPrev");
      }

      setTimeout(() => {
        isScrolling = false;
      }, scrollTimeout);
    }

  }, { passive: false });
}

function equalizeSlickHeights() {
  let maxHeight = 0;
  $(".block__custom-review-innerwrapper .slick-slide").each(function () {
    const h = $(this).outerHeight();
    if (h > maxHeight) maxHeight = h;
  });
  $(".block__custom-review-innerwrapper .slick-slide").height(maxHeight);
}

$(window).on("load resize", equalizeSlickHeights);